
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SampleStudentIconComponent } from "./sample-student-icon.svg";

export const SampleStudentIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SampleStudentIconComponent {...props} />;
};
